module.exports = __webpack_public_path__ + "img/progress_060.96cd8f17.png";